
import { includes } from 'ramda';

const isValid = (locale, supportedLocales) =>
  includes(locale, supportedLocales);

const localeFromUserConfig = ({
  languageCode,
  countryCode,
  supportedLocales,
  loading,
  error
}) => {
  if (loading || error) return null;
  if (!languageCode || !countryCode) return null;
  const userLocale = `${languageCode}-${countryCode}`;
  return isValid(userLocale, supportedLocales) ? userLocale : null;
};

const localeFromBrowserConfig = supportedLocales => {
  const browserLocale =
    typeof navigator !== 'undefined'
      ? (navigator.languages && navigator.languages[0]) ||
      navigator.language ||
      navigator.userLanguage
      : undefined;

  return isValid(browserLocale, supportedLocales) ? browserLocale : null;
};

const localeFromQueryString = supportedLocales => {
  const queryObj =
    (window.location?.search &&
      JSON.parse(
        `{"${window.location.search
          .split('?')[1]
          .replace(/&/g, '","')
          .replace(/=/g, '":"')}"}`,
        (key, value) => (key === '' ? value : decodeURIComponent(value))
      )) ||
    {};
  if (queryObj && queryObj.language && queryObj.country) {
    const queryLocale = `${queryObj.language}-${queryObj.country.toLocaleUpperCase()}`;
    return isValid(queryLocale, supportedLocales) ? queryLocale : null;
  }
  return null;
};

// eslint-disable-next-line default-param-last
const getLocale = (userLocaleConfig, supportedLocales = [], loading, error) => (
    localeFromQueryString(supportedLocales) ||
    localeFromUserConfig({
      languageCode: userLocaleConfig?.languageCode,
      countryCode: userLocaleConfig?.countryCode?.toUpperCase(),
      supportedLocales,
      loading,
      error
    }) ||
    localeFromBrowserConfig(supportedLocales) ||
    'en-US'
  );

export { getLocale };
